import React, { useEffect, useState } from "react";
import Service from "../Service/http";
import Util from "../Service/util";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import {FadeLoader} from "react-spinners";
import Pagination from "@mui/material/Pagination";
import { toast } from"react-toastify";

const ReactTableFixedColumns = withFixedColumns(ReactTable);

function Global(prop) {
  let service = new Service();
  let util = new Util();

  let [data, setData] = useState([]);
  let [loading, SetLoading] = useState(false);
  let [color, Setcolor] = useState('');
  let [background, SetBackground] = useState("#81C784");
  let [textColor, SetTextcolor] = useState("");
  let [isStudentOrCollege, SetIsStudentOrCollege] = useState(true);
  let [pages, setPages] = useState(1);
  let [page, setPage] = useState(1);
  let [limit, setLimit] = useState(20);
  let [total, setTotal] = useState(null);


  const originalWarn = console.warn;

console.warn = function (...args) {
    const arg = args && args[0];

    if (arg && arg.includes('Attempting to load version \'51\' of Google Charts')) return;

    originalWarn(...args);
};


  useEffect(() => {

    let role = util.getRole();

    if (role != "student" && role != "college") SetIsStudentOrCollege(false);
    SetLoading(true)
    service
      .get(
        "api/global/leaderboard?page=" +
        page +
        "&size=" +
        limit
      )
      .then((json) => {
        if(json.retry===true){
          toast.warn(json.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          SetLoading(false);
        }
        else{
          setData(json.docs)
          setTotal(json.total);
          setPages(json.pages);
          SetLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        SetLoading(false);
      });
  }, [page]);


  return (
    <div className="">


      {loading?<div style={{ marginTop: "10vh", marginRight:"10vh",textAlign:"center"}}><FadeLoader  margin={5} color="green" /></div>:
      <div>

        <ReactTableFixedColumns
        data={data}
        showPagination={false}
        columns={[
          {
            Header: "Rank",
            id: "row",
            accessor: "no",
            getProps: (state, rowInfo, column) => {
              return {
                style: {
                  color: (rowInfo?.original?.my) ? 'white' : 'white',
                  background: rowInfo?.original?.my ? background : "#0F9ADC",
                },
              };
            },
            width: "150",
          },
          {
            Header: "Name",
            accessor: "name",
            Cell: e => (isStudentOrCollege == false) ? <a
              className="text-secondary"
              target="_blank" href={"/coding/profile/" + e.original.user_id}> {e.value} </a> : <span>  {e.value}</span>,
            getProps: (state, rowInfo, column) => {
              return {
                style: {
                  color: (rowInfo?.original?.my) ? color : textColor,
                  background: rowInfo?.original?.my ? background : "#B2EBF2",
                },
              };
            },
            width: "30vw",
          },
          {
            Header: "Roll No",
            accessor: "roll_number",
            Cell: e => (isStudentOrCollege == false) ? <a
            className="text-secondary"
            target="_blank" href={"/coding/profile/" + e.original.user_id}> {e.value} </a> : <span>  {e.value}</span>,
            getProps: (state, rowInfo, column) => {
              return {
                style: {
                  color: (rowInfo?.original?.my) ? color : textColor,
                  background: rowInfo?.original?.my ? background : "#B2EBF2",
                },
              };
            },
            width: "30vw",
          },
          {
            Header: "Score",
            accessor: "total_score",
            Cell: (e) => (
              <span >
                {" "}
                {e.value}{" "}
              </span>
            ),
            getProps: (state, rowInfo, column) => {
              return {
                style: {
                  color: (rowInfo?.original?.my) ? 'white' : 'white',
                  background: rowInfo?.original?.my ? background : "#0F9ADC",
                },
              };
            },
            width: "10vw",
          }
        ]}
        style={{
          height: data.length>30?'110vh':'auto', // This will force the table body to overflow and scroll, since there is not enough room
          width: "80vw",
          marginTop: "2vh",
          marginLeft: "10vw",
          marginRight: "10vw",
          fontWeight: "bolder",
          fontSize:"16px",
          textAlign: "center"
        }}

        className=" -highlight text-dark h5"
      />
      <div className="container-fluid d-flex justify-content-center my-4">
        <Pagination
          count={pages}
          color="primary"
          defaultPage={1}
          page={page}
          onChange={(e, v) => {
            setPage(v);
          }}
          variant="outlined"
          shape="rounded"
        />
      </div>

      </div>}
    </div>
  );
}

export default Global;
